import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import * as React from "react";

import styles from "./index.module.scss";

import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  banner: FileHandle | null | undefined;
};

export default function SectionBanner({ className, style, banner }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <div className={styles.blurredContent}>
        {banner ? (
          <ImageViewer
            className={styles.blurredImage}
            value={banner}
            sizing="fill"
            sizes="360px"
          />
        ) : null}
      </div>
      <div className={styles.content}>
        <ImageViewer
          value={banner}
          sizing="fill"
          sizes="(min-width: 1920px) 1920px, 100vw"
        />
      </div>
    </div>
  );
}
